import React from 'react';
import { Card, Typography } from 'antd';
import AuthorizedPersonTable from '../../../components/Companies/AuthorizedPersonTable';
import type { Dispatch, SetStateAction } from 'react';

interface PlanAuthorizedPersonsCardProps {
  loading: boolean;
  isReadOnly: boolean;
  companyId?: number;
  planAuthorizedPersonIds: number[];
  setPlanAuthorizedPersonIds: Dispatch<SetStateAction<number[]>>;
  accordionOpen?: boolean;
  onAccordionToggle?: () => void;
}

const PlanAuthorizedPersonsCard: React.FC<PlanAuthorizedPersonsCardProps> = ({
  loading,
  isReadOnly,
  companyId,
  planAuthorizedPersonIds,
  setPlanAuthorizedPersonIds,
  accordionOpen,
  onAccordionToggle,
}) => {
  const { Text } = Typography;
  const isAccordionMode = typeof accordionOpen === 'boolean' && typeof onAccordionToggle === 'function';
  const isExpanded = !isAccordionMode || Boolean(accordionOpen);

  return (
    <Card
      className='br-30px mt-16px'
      loading={loading}
      title={
        isAccordionMode ? (
          <div
            role='button'
            tabIndex={0}
            onClick={onAccordionToggle}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onAccordionToggle?.();
              }
            }}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
          >
            <span>Yetkili Kişiler</span>
            <span>{isExpanded ? '-' : '+'}</span>
          </div>
        ) : (
          'Yetkili Kişiler'
        )
      }
    >
      {isExpanded && companyId ? (
        <AuthorizedPersonTable
          companyId={companyId}
          selectionFilter='planOnly'
          selectedAuthorizedPersonIds={planAuthorizedPersonIds}
          setSelectedAuthorizedPersonIds={setPlanAuthorizedPersonIds}
          readOnly={isReadOnly}
        />
      ) : isExpanded ? (
        <Text>Firma bilgisi bulunamadı.</Text>
      ) : null}
    </Card>
  );
};

export default PlanAuthorizedPersonsCard;
